const getters = {
  token: state => state.token,
  user: state => state.user,
  menu: state => state.menu
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js